import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconUnpublish(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M9.70711 15.7071C9.31658 16.0976 8.68342 16.0976 8.29289 15.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929C5.68342 10.9024 6.31658 10.9024 6.70711 11.2929L8 12.5858L8 5C8 4.44772 8.44772 4 9 4C9.55229 4 10 4.44772 10 5L10 12.5858L11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929C13.0976 11.6834 13.0976 12.3166 12.7071 12.7071L9.70711 15.7071Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 0.895432 0.89543 0 2 0H14C16.2091 0 18 1.79086 18 4V18C18 19.1046 17.1046 20 16 20H2C0.895431 20 0 19.1046 0 18V2ZM2 2L11 2V5C11 6.10457 11.8954 7 13 7H16V18H2V2ZM16 4V5H13V2H14C15.1046 2 16 2.89543 16 4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
